import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { dynatraceUtil } from '@uhg-uhcpp-sde-core/monstera-utility';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'GET_SENT_COMMUNICATION';

export const resetViewSentCommunicationApi = () => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });
  const action = useAction(() => {
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
    };
  });
  return [result, action];
};

const convertToJson = (res, args, dtrumActionId) => {
  event('API_TRANSACTION', {
    fields: {
      appVersion: process.env.PACKAGE_VERSION,
      url: window.location.href,
      endpoint: config('COMMUNICATION_URL'),
      method: 'GET',
      userInfo: args?.userInfo?.data,
      code: res.status,
      operationName: ACTION_TYPE,
      message: res.statusText,
    },
  });
  event('Dynatrace_event', {
    actionId: dtrumActionId,
    endpoint: config('FEEDBACK_URL'),
    status: 0,
    message: 'Success',
    url: window.location.href,
    result: 'success',
    operationName: ACTION_TYPE,
    uuid: args?.userInfo?.data?.uuid,
  });

  return new Promise((resolve) => {
    return res.json().then((response) => {
      return resolve({
        status: res.status,
        response,
      });
    });
  });
};

const getAction = () => {
  const action = useAction((args) => {
    const eapm = window.elasticApm;
    let dtrumActionId;
    if (eapm) {
      window.elasticApm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: true,
      });
    }
    return (dispatch) => {
      const { id = '' } = args || {};
      dispatch({ type: `${ACTION_TYPE}_CALLED` });
      dtrumActionId = dynatraceUtil.startAction(ACTION_TYPE, `${config('APIM_STARGATE_URL')}${config('COMMUNICATION_URL')}?q=${ACTION_TYPE}`);
      fetch(`${config('APIM_STARGATE_URL')}${config('COMMUNICATION_URL')}`, {
        headers: {
          allMessages: false,
          id,
          viewEmail: true,
        },
      })
        .then((res) => {
          return convertToJson(res, args, dtrumActionId);
        })
        .then((res) => {
          if (res.status !== 200) {
            if (res.status === 500) {
              throw new Error(
                'Your request was unsuccessful, please try again.'
              );
            } else {
              dispatch({
                type: `${ACTION_TYPE}_ERROR`,
                payload: res.response,
              });
            }
          } else {
            dispatch({
              type: `${ACTION_TYPE}_COMPLETED`,
              payload: res.response,
            });
          }
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });
          event('API_TRANSACTION_ERROR', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('COMMUNICATION_URL'),
              method: 'GET',
              userInfo: args?.userInfo?.data,
              operationName: ACTION_TYPE,
            },
          });

          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('COMMUNICATION_URL'),
            status: 0,
            message: 'Error',
            url: window.location.href,
            result: 'error',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.data?.uuid,
          });
        });
    };
  });
  return action;
};

export const useGetSentCommunicationApi = () => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });
  const action = getAction();
  return [result, action];
};
